// 定义导出文件
let exportfile = (val1,val2) => {
  if(val2 =='0') {
    let name = "面议";
    return name
  }  else if (val1 == val2) {
    let name = val1 / 1000 + "K";
    return name
  }  else {
    let name =  val1 /1000 + "K" + '-' + val2 / 1000 + "K";
    return name
  }
}
export default exportfile;


// WEBPACK FOOTER //
// ./src/filters/SalaryFormat/index.js